import { create } from 'mobx-persist';
import CreditProductsStore from './creditProducts.store';
import ThemeStore from './theme.store';
import UserStore from './user.store';

class RootStore {
  theme: ThemeStore;
  creditProducts: CreditProductsStore;
  user: UserStore;

  constructor() {
    this.theme = new ThemeStore();
    this.creditProducts = new CreditProductsStore();
    this.user = new UserStore(this);
  }
}

const hydrate = create({
  storage: localStorage,
});

const store = new RootStore();

hydrate('theme', store.theme);
hydrate('creditProducts', store.creditProducts);
hydrate('user', store.user);

export { RootStore, ThemeStore, CreditProductsStore, UserStore };
export default store;
